import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { api } from '../lib/api';
import type { Customer } from '../components/CustomerManagement';
import { CustomerDetailPanel } from '../components/customer-detail/CustomerDetailPanel';

/** Direkt-Link-Seite für eine einzelne Kundenakte (/customers/:id).
 *  Die Hauptbedienung läuft inline in der Kundenliste; diese Seite ist
 *  der Voll-Ansicht-/Deep-Link-Fallback und nutzt dasselbe Panel. */
export default function CustomerDetail() {
  const { id } = useParams();
  const customerId = Number(id);
  const navigate = useNavigate();
  const [customer, setCustomer] = useState<Customer | null>(null);

  useEffect(() => {
    api.get<Customer>(`/api/customers/${customerId}`).then(setCustomer).catch(() => setCustomer(null));
  }, [customerId]);

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate('/customers')} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 mb-4">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Kundenliste
        </button>
        <h1 className="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white mb-6" translate="no">
          {customer?.name || 'Kunde'}
        </h1>
        <CustomerDetailPanel customerId={customerId} />
      </div>
    </div>
  );
}
